import MoreVertIcon from "@mui/icons-material/MoreVert"
import { Menu } from "@mui/material"
import IconButton from "@mui/material/IconButton"
import type React from "react"
import { useEffect, useState } from "react"
import authService from "services/authService"
import type { ILicensePool } from "types/licensePoolTypes"
import { UserRoles } from "types/userRoles"
import { DeleteLicensePoolDialog } from "./DeleteLicensePoolDialog"
import { UpdateLicensePoolDialog } from "./UpdateLicensePoolDialog"

type Props = {
  licensePool: ILicensePool
}

export function LicensePoolCardMenu({ licensePool }: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [openMenu, setOpenMenu] = useState(false)
  const [roles, setRoles] = useState<Array<string>>()

  useEffect(() => {
    authService.getRolesAssignedToUser().then((roles) => {
      setRoles(roles)
    })
  }, [])

  const handleClickMenuClose = () => {
    setAnchorEl(null)
    setOpenMenu(false)
  }

  const handleClickMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
    setOpenMenu(true)
  }

  return (
    <>
      <IconButton aria-label="edit" size="small" onClick={handleClickMenuOpen}>
        <MoreVertIcon></MoreVertIcon>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleClickMenuClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        {roles?.includes(UserRoles.HIAB_ADMIN) && (
          <UpdateLicensePoolDialog licensePool={licensePool} />
        )}
        {roles?.includes(UserRoles.HIAB_ADMIN) && (
          <DeleteLicensePoolDialog licensePool={licensePool} />
        )}
      </Menu>
    </>
  )
}
